import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { locale, loadMessages } from 'devextreme/localization';
import deMessages from 'devextreme/localization/messages/de.json';
import enMessages from 'devextreme/localization/messages/en.json';
import esMessages from 'devextreme/localization/messages/es.json';
import frMessages from 'devextreme/localization/messages/fr.json';
import itMessages from 'devextreme/localization/messages/it.json';

const SUPPORTED_LOCALES = ['en', 'fr', 'de', 'it', 'es'] as const;
type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

i18n.use(LanguageDetector).init({
  fallbackLng: 'en',
  supportedLngs: [...SUPPORTED_LOCALES],
  resources: {},
  initImmediate: false,
});

export function initDevExtremeLocalization(): void {
  loadMessages(enMessages);
  loadMessages(frMessages);
  loadMessages(deMessages);
  loadMessages(itMessages);
  loadMessages(esMessages);

  const lang = i18n.language.split('-')[0].toLowerCase();
  locale(SUPPORTED_LOCALES.includes(lang as SupportedLocale) ? lang : 'en');
}
